/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './requestPlcOperationSignature.defs.js'
export { main as default } from './requestPlcOperationSignature.defs.js'
